'use client'
import { BsChevronDown } from 'react-icons/bs'
import Link from 'next/link'
import { usePathname } from 'next/navigation'

type LinkProps = {
  title?: string
  url: string
  className?: string
  children?: React.ReactNode
  onClose?:()=>void
}

export const DesktopLink = ({ title, url, className, children }: LinkProps) => {
  const pathname = usePathname()
  const isActive = pathname === url

  return (
    <li className={`group ${className}`}>
      <Link
        href={url}
        className={`flex items-center gap-1 transition-all hover:text-orange lg:py-10 ${isActive ? 'text-orange' : ''}`}
      >
        <p>{title}</p>
        {children && (
          <div className='mt-1 transition-all duration-300 hover:text-orange group-hover:mt-0 group-hover:rotate-180 rtl:mt-0 rtl:group-hover:mb-1'>
            <BsChevronDown aria-label='chrvron-down' className='leading-3' />
          </div>
        )}
      </Link>
      {children}
    </li>
  )
}

export const MobileLink = ({ url, title, className, children,onClose }: LinkProps) => {
  const pathname = usePathname()
  const isActive = pathname === url

  return (
    <li className={`${className}`}>
      <Link
      onClick={onClose}
        href={url}
        className={`ps-4 lg:py-10 ${isActive ? 'text-orange' : 'text-black'}`}
      >
        {title}
      </Link>
      {children}
    </li>
  )
}
